<template>
  <div class="a-transition-fade m-login-callback">
    <AtomLoadingPrimary :loading-text="$t('mLogOut.message')"/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeLogOut'
}
</script>
